import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject, Subscription, filter, of, pipe } from "rxjs";
import {
    map,
    distinctUntilChanged,
    takeUntil,
    switchMap,
    combineLatest,
    combineLatestWith,
} from "rxjs/operators";
import { CommonStateService, MenuItem } from "../state";
import { environment } from "../environments/environment";
// TODO: to review.
import { ErrorHandlerService } from "./errorhandler/error-handler.service";
import { ErrorObject } from "./errorhandler/error-object";
import { ErrorTypeEnum } from "./shared/enums.model";
import { CustomToastOption } from "./shared/custom-toast-options";
import { MasterDataStateService } from "../state/master-data/service";
import { defineCustomElements, addTheme } from "corporate-ui";
import { theme as scaniaTheme } from "scania-theme";
import {
    MSAL_GUARD_CONFIG,
    MsalBroadcastService,
    MsalGuardConfiguration,
    MsalService,
} from "@azure/msal-angular";
import {
    AccountInfo,
    AuthenticationResult,
    EventMessage,
    EventType,
    InteractionStatus,
    PopupRequest,
    RedirectRequest,
} from "@azure/msal-browser";
import { HttpClient } from "@angular/common/http";
import { get } from "lodash";
import { AuthService } from "./shared/auth.service";

defineCustomElements([
    "c-theme",
    "c-header",
    "c-footer",
    "c-content",
    "c-navigation",
    "c-icon",
]);
addTheme(scaniaTheme);

@Component({
    selector: "#app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, OnDestroy {
    profile$: Observable<any>;
    menu$: Observable<MenuItem[]>;
    activeMenu$: Observable<MenuItem>;
    subscriptions = new Subscription();
    isLoggedIn$: Observable<boolean>;

    //new added
    private readonly _destroying$ = new Subject<void>();
    account: AccountInfo | null = null;

    constructor(
        private authService: AuthService,
        private commonService: CommonStateService,
        private errHandler: ErrorHandlerService,
        private toastr: ToastrService,
        private masterDataService: MasterDataStateService,
    ) {
        this.authService.userInfo.subscribe((account) => {
            this.account = account;
            console.log("Current account:", this.account);
        });
        this.profile$ = this.authService.userInfo.pipe(
            distinctUntilChanged(),
            map((account) => (account ? account : {}))
        );

        this.subscriptions.add(
            this.authService.userInfo.subscribe((user) => {
                if (
                    !!user &&
                    user.username != null &&
                    this.authService.validateToken(user.idTokenClaims)
                ) {
                    this.masterDataService.loadMasterData();
                    this.isLoggedIn$ = of(true);
                }
            })
        );

        this.menu$ = this.commonService.getMenus();
        this.activeMenu$ = this.commonService.getActiveMenu();
        this.subscriptions.add(
            this.errHandler.errorEvent.subscribe((err: ErrorObject) => this.onError(err))
        );

    }

    ngOnInit(): void {

        this.isLoggedIn$ = this.authService.isUserLoggedIn.pipe(
            combineLatestWith(this.authService.isUserAuthorized$),
            map(([isUserLoggedIn, isUserAuthorized]) => isUserLoggedIn && isUserAuthorized)
        );

        document.body.setAttribute("data-env", environment.currentEnvironment);
        if (environment.currentEnvironment !== "prod") {
            document.title += " " + environment.currentEnvironment;
        }
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }

    // TODO: add to common state.
    onError(error: ErrorObject) {
        const errorObj = this.errHandler.getError();
        if (errorObj != null) {
            if (errorObj.errType === ErrorTypeEnum.Error) {
                const errOption = new CustomToastOption().getErrorOptions();
                this.toastr.error(
                    errorObj.errorText,
                    errorObj.originator,
                    errOption
                );
            } else if (errorObj.errType === ErrorTypeEnum.Info) {
                const infoOption = new CustomToastOption().getInfoOptions();
                this.toastr.info(
                    errorObj.errorText,
                    errorObj.originator,
                    infoOption
                );
            } else if (errorObj.errType === ErrorTypeEnum.Success) {
                const successOption =
                    new CustomToastOption().getSuccessOptions();
                this.toastr.success(
                    errorObj.errorText,
                    errorObj.originator,
                    successOption
                );
            } else if (errorObj.errType === ErrorTypeEnum.Warning) {
                const warnOption = new CustomToastOption().getWarningOptions();
                this.toastr.warning(
                    errorObj.errorText,
                    errorObj.originator,
                    warnOption
                );
            } else if (errorObj.errType === ErrorTypeEnum.Custom) {
                const custOption = new CustomToastOption().getCustomOptions(
                    "customErrMsgClass",
                    "customTitleClass"
                );
                this.toastr.error(
                    errorObj.errorText,
                    errorObj.originator,
                    custOption
                );
            }
        }
    }
}
